import React, { useEffect, FC } from 'react';

import { useDispatch } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { Redirect, Router } from '@reach/router';
import i18n from '@/i18n/i18n';

import { uiActions } from '@/redux/actions';
import { LayoutPaths, Pages, Paths, ProtectedRoute, PublicRoute } from '@/pages/routers';
import Auth from '@/layouts/Auth';
import Guest from '@/layouts/Guest';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const TypeScriptRedirect = Redirect as unknown as FC<any>;
  const TypeScriptRouter = Router as unknown as FC<any>;

  useEffect(() => {
    const updateSize = (): void => {
      dispatch(uiActions.setDevice(window.innerWidth));
    };
    window.addEventListener('resize', updateSize);
    return (): void => window.removeEventListener('resize', updateSize);
  }, [dispatch]);

  return (
    <I18nextProvider i18n={i18n}>
      <div className="App">
        <TypeScriptRouter primary={false}>
          <Guest path={LayoutPaths.Guest}>
            <PublicRoute path={Paths.Login} component={Pages.Login} />
            <PublicRoute path={Paths.Register} component={Pages.Login} />
            <ProtectedRoute path={Paths.Project} component={Pages.Project} />
            <ProtectedRoute path={Paths.Account} component={Pages.Account} />
            <TypeScriptRedirect from={Paths.Rest} to={Paths.Login} noThrow />
          </Guest>

          <Auth path={LayoutPaths.Auth}>
            <TypeScriptRedirect from={Paths.Rest} to={`${LayoutPaths.Auth}${Paths.Login}`} noThrow />
          </Auth>
        </TypeScriptRouter>
      </div>
    </I18nextProvider>
  );
};

export default App;
